import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot } from "firebase/firestore";

export function useImages(env, client) {
  const [loadedImages, setLoadedImages] = useState(false);
  const [images, setImages] = useState(null);

  useEffect(() => {
    setLoadedImages(false);
    if (!client) {
      setLoadedImages(true);
      return () => [];
    }
    const ref = collection(db, "kiosk", env, "client", client, "images");
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = {};
      snapshot.docs.forEach((doc) => {
        data[doc.id] = {
          id: doc.id,
          ...doc.data()
        };
      });
      setImages(data);
      setLoadedImages(true);
    });
    return () => unsub();
  }, [env, client]);

  return { loadedImages, images };
}